import styled from "styled-components"

export const UserInputWrap = styled.div`
  flex-grow: 1;
`
